const modalSelector = '.aogeo-search-modal-v43';
const solutionProcessHandles = new Set([
  'laser-welding-process',
  'laser-cutting-process',
  'laser-cleaning-process',
  'laser-marking-process',
  'laser-engraving-process',
  'laser-etching-process',
  'laser-drilling-process',
  'laser-micromachining-process',
  'laser-automation-process'
]);
const caseHandles = new Set([
  'applications-cases',
  'precision-component-laser-welding',
  'precision-cutting-micromachining',
  'product-marking-traceability',
  'inline-laser-coding',
  'automated-laser-welding-line',
  'laser-cleaning-surface-preparation'
]);
let searchTimer;
let activeRequest;

function escapeHtml(value) {
  return String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  })[character]);
}

function localeCopy() {
  const zh = document.documentElement.lang.toLowerCase().startsWith('zh');
  return zh ? {
    all: '全部',
    product: '设备',
    solution: '行业方案',
    case: '应用案例',
    support: '服务支持',
    category: '设备分类',
    equipmentBadge: '设备',
    solutionBadge: '方案',
    caseBadge: '案例',
    pageBadge: '页面',
    searching: '搜索中',
    noResults: '没有找到匹配内容，请尝试设备名称、材料、工艺或行业关键词。',
    error: '搜索暂时未能加载，您仍可按回车查看全部搜索结果。'
  } : {
    all: 'All',
    product: 'Equipment',
    solution: 'Solutions',
    case: 'Cases',
    support: 'Support',
    category: 'Categories',
    equipmentBadge: 'EQUIPMENT',
    solutionBadge: 'SOLUTION',
    caseBadge: 'CASE',
    pageBadge: 'PAGE',
    searching: 'Searching',
    noResults: 'No matching content. Try an equipment, material, process or industry keyword.',
    error: 'Search could not load. Press Enter to view all search results.'
  };
}

function currentRoot() {
  return window.Shopify?.routes?.root || '/';
}

function localizedUrl(value) {
  const url = String(value || '');
  const root = currentRoot();
  if (root === '/' || !url.startsWith('/') || url.startsWith(root)) return url;
  return root + url.replace(/^\/+/, '');
}

function cleanSummary(value) {
  return String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

function displayTitle(value) {
  const title = String(value || '').trim();
  if (document.documentElement.lang.toLowerCase().startsWith('zh') && title.includes('|')) {
    return title.split('|')[0].trim();
  }
  return title;
}

function pageKind(page) {
  const handle = page.handle || '';
  if (
    handle === 'solutions' ||
    handle.includes('laser-solutions-') ||
    handle.includes('laser-processing-') ||
    solutionProcessHandles.has(handle)
  ) return 'solution';
  if (caseHandles.has(handle)) return 'case';
  return 'support';
}

function setTab(root, value) {
  if (!root) return;
  root.querySelectorAll('[data-aogeo-search-tab]').forEach((button) => {
    const active = button.dataset.aogeoSearchTab === value;
    button.setAttribute('aria-selected', active ? 'true' : 'false');
  });
  root.querySelectorAll('[data-aogeo-search-group]').forEach((group) => {
    group.hidden = value !== 'all' && group.dataset.aogeoSearchGroup !== value;
  });
}

function intentOrder(term) {
  const order = { product: 1, solution: 2, case: 3, support: 4 };
  const caseIntent = /(案例|应用|效果|样品|测试|演示|视频|生产线|case|application|sample|video)/i;
  const solutionIntent = /(汽车|半导体|医疗|新能源|航空|不锈钢|钢铁|铜|铝|钛|镍|玻璃|陶瓷|蓝宝石|塑料|聚合物|电池材料|金属箔|碳纤维|复合材料|涂层|薄膜|木材|材料|工艺|方案|automotive|medical|semiconductor|steel|copper|aluminum|glass|ceramic|material|process|solution)/i;
  if (caseIntent.test(term)) {
    order.case = 1;
    order.product = 2;
    order.solution = 3;
  } else if (solutionIntent.test(term)) {
    order.solution = 1;
    order.product = 2;
    order.case = 3;
  }
  return order;
}

function pageRows(items, type) {
  const copy = localeCopy();
  const badge = type === 'solution' ? copy.solutionBadge : type === 'case' ? copy.caseBadge : copy.pageBadge;
  return '<ul class="aogeo-search-page-list list-unstyled">' + items.map((item) => {
    const summary = cleanSummary(item.body || item.excerpt || item.excerpt_or_content || '');
    const summaryMarkup = summary ? '<small>' + escapeHtml(summary.slice(0, 108)) + '</small>' : '';
    return '<li><a data-aogeo-result-link href="' + escapeHtml(localizedUrl(item.url)) + '">' +
      '<span class="aogeo-search-page-list__type">' + badge + '</span>' +
      '<span class="aogeo-search-page-list__copy"><strong>' + escapeHtml(displayTitle(item.title)) + '</strong>' +
      summaryMarkup + '</span>' +
      '<span class="aogeo-search-page-list__arrow">↗</span></a></li>';
  }).join('') + '</ul>';
}

function productCards(products) {
  const copy = localeCopy();
  return '<div class="aogeo-smart-products">' + products.map((item) => {
    const imageValue = item.featured_image?.url || item.image || '';
    const image = typeof imageValue === 'string' ? imageValue : imageValue?.url || '';
    return '<a data-aogeo-result-link class="aogeo-smart-product" href="' + escapeHtml(localizedUrl(item.url)) + '">' +
      '<span class="aogeo-smart-product__image">' +
      (image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy">' : '<span>LASER</span>') +
      '</span><span class="aogeo-smart-product__copy"><small>' + escapeHtml(copy.equipmentBadge) + '</small><strong>' +
      escapeHtml(displayTitle(item.title)) + '</strong><span>' + escapeHtml(item.type || item.vendor || '') +
      '</span></span><span class="aogeo-smart-product__arrow">↗</span></a>';
  }).join('') + '</div>';
}

function groupMarkup(type, index, label, count, content, order) {
  if (!count) return '';
  return '<section class="aogeo-search-group" data-aogeo-search-group="' + type +
    '" style="--aogeo-search-order:' + order + '">' +
    '<div class="aogeo-search-group__heading"><span>' + index + '</span><h3>' +
    escapeHtml(label) + '</h3><small>' + count + '</small></div>' + content + '</section>';
}

function renderResults(root, payload, term) {
  const copy = localeCopy();
  const results = payload?.resources?.results || {};
  const products = results.products || [];
  const collections = results.collections || [];
  const pages = results.pages || [];
  const articles = results.articles || [];
  const queries = results.queries || [];
  const groups = { solution: [], case: [], support: [] };
  pages.forEach((page) => groups[pageKind(page)].push(page));
  articles.forEach((article) => groups.support.push(article));

  const counts = {
    product: products.length + collections.length,
    solution: groups.solution.length,
    case: groups.case.length,
    support: groups.support.length
  };
  const total = counts.product + counts.solution + counts.case + counts.support;
  const target = root.querySelector('[ref="predictiveSearchResults"]');
  if (!target) return;
  const input = root.querySelector('[data-aogeo-smart-search-input]');
  if (input) input.setAttribute('aria-expanded', 'true');

  if (!total) {
    target.innerHTML = '<div id="predictive-search-results" class="predictive-search-dropdown aogeo-search-results" data-search-results>' +
      '<div class="aogeo-search-no-results"><span>0</span><p>' + escapeHtml(copy.noResults) + '</p></div></div>';
    return;
  }

  const tabs = [
    ['all', copy.all, total],
    ['product', copy.product, counts.product],
    ['solution', copy.solution, counts.solution],
    ['case', copy.case, counts.case],
    ['support', copy.support, counts.support]
  ].filter((entry) => entry[0] === 'all' || entry[2] > 0).map((entry, index) =>
    '<button type="button" role="tab" aria-selected="' + (index === 0 ? 'true' : 'false') +
    '" data-aogeo-search-tab="' + entry[0] + '">' + escapeHtml(entry[1]) +
    ' <span>' + entry[2] + '</span></button>'
  ).join('');

  const collectionLinks = collections.length ?
    '<div class="aogeo-search-collections"><strong>' + escapeHtml(copy.category) + '</strong>' +
    collections.map((item) => '<a data-aogeo-result-link href="' + escapeHtml(localizedUrl(item.url)) + '">' +
      escapeHtml(item.title) + ' <span>↗</span></a>').join('') + '</div>' : '';
  const productContent = collectionLinks + (products.length ? productCards(products) : '');
  const order = intentOrder(term);
  const queryLinks = queries.length ?
    '<div class="aogeo-search-query-suggestions">' + queries.map((item) =>
      '<a data-aogeo-result-link href="' + escapeHtml(localizedUrl(item.url)) + '">' +
      escapeHtml(item.styled_text || item.text) + '</a>').join('') + '</div>' : '';

  const html = '<div id="predictive-search-results" class="predictive-search-dropdown aogeo-search-results" data-search-results data-aogeo-search-results>' +
    '<div class="predictive-search-results__inner">' + queryLinks +
    '<div class="aogeo-search-tabs" role="tablist">' + tabs + '</div>' +
    '<div class="aogeo-search-groups">' +
    groupMarkup('product', '01', copy.product, counts.product, productContent, order.product) +
    groupMarkup('solution', '02', copy.solution, counts.solution, pageRows(groups.solution, 'solution'), order.solution) +
    groupMarkup('case', '03', copy.case, counts.case, pageRows(groups.case, 'case'), order.case) +
    groupMarkup('support', '04', copy.support, counts.support, pageRows(groups.support, 'support'), order.support) +
    '</div></div></div>';
  target.innerHTML = html;
}

function renderError(root) {
  const target = root.querySelector('[ref="predictiveSearchResults"]');
  if (!target) return;
  target.innerHTML = '<div id="predictive-search-results" class="predictive-search-dropdown aogeo-search-results" data-search-results>' +
    '<div class="aogeo-search-no-results"><span>!</span><p>' + escapeHtml(localeCopy().error) + '</p></div></div>';
  const input = root.querySelector('[data-aogeo-smart-search-input]');
  if (input) input.setAttribute('aria-expanded', 'true');
}

async function runSearch(input) {
  const root = input.closest(modalSelector);
  const term = input.value.trim();
  const target = root?.querySelector('[ref="predictiveSearchResults"]');
  if (!root || !target) return;
  if (!term) return;

  if (activeRequest) activeRequest.abort();
  activeRequest = new AbortController();
  target.innerHTML = '<div class="aogeo-search-loading" aria-live="polite"><span></span><p>' + escapeHtml(localeCopy().searching) + '</p></div>';

  try {
    const types = ['product', 'page', 'article'];
    const requests = types.map(async (type) => {
      const searchUrl = new URL(currentRoot() + 'search', window.location.origin);
      searchUrl.searchParams.set('q', term);
      searchUrl.searchParams.set('type', type);
      searchUrl.searchParams.set('options[prefix]', 'last');
      searchUrl.searchParams.set('section_id', 'aogeo-smart-search-results-v43');
      const response = await fetch(searchUrl.toString(), {
        signal: activeRequest.signal,
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error('Search request failed ' + response.status);
      const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
      return Array.from(documentResult.querySelectorAll('[data-aogeo-result-entry]')).map((entry) => ({
        kind: entry.dataset.kind || type,
        handle: entry.dataset.handle || '',
        title: entry.dataset.title || '',
        url: localizedUrl(entry.dataset.url || ''),
        body: entry.dataset.summary || '',
        type: entry.dataset.subtype || '',
        image: entry.dataset.image || ''
      }));
    });
    const entries = (await Promise.all(requests)).flat();
    const results = { products: [], collections: [], pages: [], articles: [], queries: [] };
    entries.forEach((entry) => {
      if (entry.kind === 'product') results.products.push(entry);
      else if (entry.kind === 'article') results.articles.push(entry);
      else results.pages.push(entry);
    });
    renderResults(root, { resources: { results } }, term);
  } catch (error) {
    if (error.name !== 'AbortError') { renderError(root); const target = root.querySelector('[ref="predictiveSearchResults"]'); if (target) target.dataset.aogeoSearchError = error.message; }
  }
}

document.addEventListener('input', (event) => {
  const input = event.target.closest('[data-aogeo-smart-search-input]');
  if (!input) return;
  window.clearTimeout(searchTimer);
  const root = input.closest(modalSelector);
  if (!input.value.trim()) {
    input.setAttribute('aria-expanded', 'false');
    window.location.reload();
    return;
  }
  searchTimer = window.setTimeout(() => runSearch(input), 180);
});

document.addEventListener('click', (event) => {
  const tab = event.target.closest('[data-aogeo-search-tab]');
  if (tab) {
    setTab(tab.closest(modalSelector), tab.dataset.aogeoSearchTab);
    return;
  }
  const queryButton = event.target.closest('[data-aogeo-search-query]');
  if (queryButton) {
    const root = queryButton.closest(modalSelector);
    const input = root?.querySelector('[data-aogeo-smart-search-input]');
    if (!input) return;
    input.value = queryButton.dataset.aogeoSearchQuery || '';
    input.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: input.value }));
    input.focus();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === '/' && !event.metaKey && !event.ctrlKey && !event.altKey) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLTextAreaElement) && !target?.isContentEditable) {
      const trigger = document.querySelector('[data-aogeo-search-trigger]');
      if (trigger) {
        event.preventDefault();
        trigger.click();
      }
    }
  }

  const input = event.target.closest('[data-aogeo-smart-search-input]');
  if (!input || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
  const root = input.closest(modalSelector);
  const links = Array.from(root.querySelectorAll('[data-aogeo-result-link]')).filter((link) => link.offsetParent !== null);
  if (!links.length) return;
  event.preventDefault();
  (event.key === 'ArrowDown' ? links[0] : links[links.length - 1]).focus();
});
